module.exports = __webpack_public_path__ + "static/img/android.aee42d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/android.png
// module id = KUj8
// module chunks = 1